import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import IconClose from 'components/icons/iconClose';
import BrowserOnly from 'components/consumer/BrowserOnly';
import MobileOnly from 'components/consumer/MobileOnly';
import PromotionText from './PromotionText';
import PromotionSale from './PromotionSale';
const PromotionContent = t0 => {
  const $ = _c(13);
  const {
    mainContent,
    subContent,
    displayValue,
    countdownToggle,
    hidePromoBar,
    textColor,
    topBannerText
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <IconClose width="10" height="10" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== hidePromoBar) {
    t2 = <BrowserOnly><MobileOnly><button type="button" className="md:hidden [background:none] border-0 [&_svg_path]:fill-white focus-visible:outline-offset-[-5px] items-center cursor-pointer flex h-[30px] justify-center p-2.5 absolute right-0 top-0 w-[30px]" onClick={hidePromoBar}>{t1}</button></MobileOnly></BrowserOnly>;
    $[1] = hidePromoBar;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== countdownToggle || $[4] !== displayValue || $[5] !== mainContent || $[6] !== subContent || $[7] !== textColor || $[8] !== topBannerText) {
    t3 = <div className="text-[#dbeded] min-h-[50px] -top-px w-full flex items-center justify-center font-bold text-base max-[767px]:min-h-[60px] max-[767px]:text-center max-[767px]:text-sm [&_a]:text-gray-light5 [&_a]:underline"><BrowserOnly>{countdownToggle ? <span className="flex absolute mx-auto my-0 left-0 right-0 justify-center items-center max-w-[70vw] max-[767px]:block max-[767px]:flex-col max-[767px]:max-w-[85vw] max-[767px]:leading-[1.8]"><PromotionText mainContent={mainContent} subContent={subContent} textColor={textColor} topBannerText={topBannerText} /><PromotionSale displayValue={displayValue} textColor={textColor} /></span> : <span className="flex absolute mx-auto my-0 left-0 right-0 justify-center items-center max-w-[70vw] max-[767px]:block max-[767px]:flex-col max-[767px]:max-w-[85vw] max-[767px]:leading-[1.8]"><PromotionText mainContent={mainContent} subContent={subContent} topBannerText={topBannerText} /></span>}</BrowserOnly></div>;
    $[3] = countdownToggle;
    $[4] = displayValue;
    $[5] = mainContent;
    $[6] = subContent;
    $[7] = textColor;
    $[8] = topBannerText;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== t2 || $[11] !== t3) {
    t4 = <>{t2}{t3}</>;
    $[10] = t2;
    $[11] = t3;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  return t4;
};
PromotionContent.propTypes = {
  countdownToggle: PropTypes.bool.isRequired,
  displayValue: PropTypes.array.isRequired,
  hidePromoBar: PropTypes.func.isRequired,
  mainContent: PropTypes.string.isRequired,
  subContent: PropTypes.string,
  textColor: PropTypes.string.isRequired,
  topBannerText: PropTypes.string
};
export default PromotionContent;